export const QS_LOCAL_STORAGE_KEY = 'saved_qs';
export const FILTER_TAB_LOCAL_STORAGE_KEY = 'selected_tab';
export const ADDITIONAL_INFORMATION_GTM_RESULTS = 'questionnaire_gtm_results';
export const ONBOARDING_PROGRESS_INDICATOR_OPEN = 'progress_indicator_open';
export const UPS_SAVINGS_MODAL_DISMISSED = 'ups_savings_modal_dismissed';
export const UPS_SAVINGS_MODAL_DISMISS_DATA = 'ups_savings_modal_data';
export const NEW_EXPERIENCE_OPT_IN = 'new_experience_opt_in';
export const NEW_EXP_BANNER_DISMISSED_DATE = 'new_exp_banner_dismissed_date';
export const WIX_PRO_PLAN_NOTIFICATION_DISMISSED = 'wix_pro_plan_notification_dismissed';
export const REFER_DESKTOP_MESSAGE_DISMISSED = 'refer_desktop_message_dismissed';
export const JUST_ONBOARDED = 'just_onboarded';
export const SHOW_PROGRESS_METER = 'show_progress_meter';
export const SM_SUCCESSFULLY_CONNECTED_NOTIFICATION_DISMISSED =
  'sm_successfully_connected_notification_dismissed';
export const BTF_NOTICE_LAST_SEEN = 'btf_notice_last_seen';
export const IBD_MODAL_DISMISSED = 'ibd_modal_dismissed';
